// Angular modules
import { Component } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

// Services
import { TitleService } from '@services/title.service';

// Components
import { ProgressBarComponent } from '@blocks/progress-bar/progress-bar.component';
import { NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { LoadingService } from '@services/loading.service';
import { AuthService } from './services/auth.service';
import { SessionNotificationService } from './services/session-notification.service';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, ProgressBarComponent, NgIf]
})
export class AppComponent implements OnInit, OnDestroy {
  private titleSub?: Subscription;
  private sessionRevokedSub?: Subscription;
  private logoutTimer?: ReturnType<typeof setTimeout>;

  constructor
    (
      public titleService: TitleService,
      public  loadingService: LoadingService,
      private authService: AuthService,
      private sessionNotifications: SessionNotificationService,
      private notificationService: NotificationService,
    ){}

  public ngOnInit(): void {
     this.titleService.setPageTitle("WiInvoice");
     this.sessionRevokedSub = this.sessionNotifications.userRevoked$.subscribe(() => {
       if (this.logoutTimer !== undefined) return;
       this.notificationService.sessionRevoked();
       this.logoutTimer = setTimeout(() => {
         this.logoutTimer = undefined;
         this.authService.logout('');
       }, 3000);
     });
     this.sessionNotifications.checkCurrentSession();
  }

  public ngOnDestroy(): void {
    this.titleSub?.unsubscribe();
    this.sessionRevokedSub?.unsubscribe();
    if (this.logoutTimer !== undefined) clearTimeout(this.logoutTimer);
  }
}
